export default function ImprintPage() {
  return (
    <div className="min-h-screen bg-white pt-32 pb-20 px-6">
      <div className="max-w-4xl mx-auto">
        <h1 className="font-['Cormorant_Garamond'] text-5xl md:text-6xl font-light text-gray-900 mb-12 text-center">
          LEGAL NOTICE
        </h1>

        <div className="space-y-12 font-['Montserrat'] text-sm text-gray-700 leading-relaxed">
          {/* Publisher */}
          <section>
            <h2 className="font-['Cormorant_Garamond'] text-3xl font-light text-gray-900 mb-4">
              1. Site Publisher
            </h2>
            <p className="mb-2">
              <strong>Company Name:</strong> [Company Name]
            </p>
            <p className="mb-2">
              <strong>Legal Form:</strong> [Legal Form]
            </p>
            <p className="mb-2">
              <strong>Share Capital:</strong> [Amount] euros
            </p>
            <p className="mb-2">
              <strong>Registered Office:</strong> [Complete Address]
            </p>
            <p className="mb-2">
              <strong>SIRET Number:</strong> [SIRET Number]
            </p>
            <p className="mb-2">
              <strong>VAT Number:</strong> [VAT Number]
            </p>
            <p className="mb-2">
              <strong>Publication Director:</strong> [Name]
            </p>
            <p className="mb-2">
              <strong>Contact:</strong> contact@example.com | +33 (7) 49 23 94 72
            </p>
          </section>

          {/* Hosting */}
          <section>
            <h2 className="font-['Cormorant_Garamond'] text-3xl font-light text-gray-900 mb-4">
              2. Hosting
            </h2>
            <p className="mb-2">
              This site is hosted by:
            </p>
            <p className="mb-2">
              <strong>Website:</strong>{' '}
              <a 
                href="https://readdy.ai" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-900 hover:underline cursor-pointer"
              >
                https://readdy.ai
              </a>
            </p>
          </section>

          {/* Intellectual Property */}
          <section>
            <h2 className="font-['Cormorant_Garamond'] text-3xl font-light text-gray-900 mb-4">
              3. Intellectual Property
            </h2>
            <p className="mb-4">
              The entire content of this site (structure, texts, logos, images, videos, graphics, etc.) is the exclusive property of [Company Name] or its partners, unless otherwise stated.
            </p>
            <p className="mb-4">
              Any reproduction, representation, modification, publication, or adaptation of all or part of the site's elements, regardless of the means or process used, is prohibited without prior written authorization from [Company Name].
            </p>
            <p>
              Any unauthorized use of the site or any of its elements will be considered as constituting an infringement and prosecuted in accordance with the provisions of Articles L.335-2 and following of the French Intellectual Property Code.
            </p>
          </section>

          {/* Copyright and Image Rights */}
          <section>
            <h2 className="font-['Cormorant_Garamond'] text-3xl font-light text-gray-900 mb-4">
              4. Copyright and Image Rights
            </h2>
            <p className="mb-4">
              All photographs and images published on this site are the exclusive property of [Company Name] and are protected by copyright.
            </p>
            <p className="mb-4">
              The persons appearing in the photographs have given their express consent for the use of their image on this site. Any use, reproduction, or distribution of these images without prior authorization is strictly prohibited.
            </p>
            <p>
              For any request regarding image rights or to exercise your right to object to the publication of your image, please contact us at: contact@example.com
            </p>
          </section>

          {/* Personal Data */}
          <section>
            <h2 className="font-['Cormorant_Garamond'] text-3xl font-light text-gray-900 mb-4">
              5. Personal Data Protection
            </h2>
            <p className="mb-4">
              In accordance with the General Data Protection Regulation (GDPR) and the French Data Protection Act of January 6, 1978, as amended, you have the right to access, rectify, delete, and port your personal data.
            </p>
            <p className="mb-4">
              You can also object to the processing of your data or request limitation of this processing.
            </p>
            <p className="mb-4">
              To exercise these rights or for any questions regarding the processing of your data, please contact us at: contact@example.com
            </p>
            <p>
              For more information, please consult our{' '}
              <a href="/privacy" className="text-gray-900 hover:underline cursor-pointer">
                Privacy Policy
              </a>
              .
            </p>
          </section>

          {/* Cookies */}
          <section>
            <h2 className="font-['Cormorant_Garamond'] text-3xl font-light text-gray-900 mb-4">
              6. Cookies
            </h2>
            <p className="mb-4">
              This site may use cookies to improve user experience and analyze site traffic.
            </p>
            <p className="mb-4">
              You can configure your browser to refuse cookies or to be notified when a cookie is stored. However, disabling cookies may affect certain site functionalities.
            </p>
            <p>
              For more information about cookies and how to manage them, please consult our Privacy Policy.
            </p>
          </section>

          {/* Hyperlinks */}
          <section>
            <h2 className="font-['Cormorant_Garamond'] text-3xl font-light text-gray-900 mb-4">
              7. Hyperlinks
            </h2>
            <p className="mb-4">
              This site may contain links to other websites. [Company Name] cannot be held responsible for the content of these external sites or for any damages resulting from their use.
            </p>
            <p>
              The creation of hyperlinks to this site requires prior written authorization from [Company Name].
            </p>
          </section>

          {/* Liability */}
          <section>
            <h2 className="font-['Cormorant_Garamond'] text-3xl font-light text-gray-900 mb-4">
              8. Liability
            </h2>
            <p className="mb-4">
              [Company Name] strives to provide accurate and up-to-date information on this site. However, it cannot guarantee the accuracy, completeness, or timeliness of the information provided.
            </p>
            <p className="mb-4">
              [Company Name] reserves the right to correct the site's content at any time and without notice.
            </p>
            <p>
              [Company Name] cannot be held responsible for any direct or indirect damages resulting from access to or use of this site.
            </p>
          </section>

          {/* Terms of Use */}
          <section>
            <h2 className="font-['Cormorant_Garamond'] text-3xl font-light text-gray-900 mb-4">
              9. Terms of Use
            </h2>
            <p className="mb-4">
              By using this site, you agree to comply with these legal notices and applicable laws.
            </p>
            <p>
              Any fraudulent or abusive use of the site may result in legal action.
            </p>
          </section>

          {/* Applicable Law */}
          <section>
            <h2 className="font-['Cormorant_Garamond'] text-3xl font-light text-gray-900 mb-4">
              10. Applicable Law and Jurisdiction
            </h2>
            <p className="mb-4">
              These legal notices are governed by French law.
            </p>
            <p>
              In case of dispute and in the absence of an amicable resolution, the courts of [City] shall have exclusive jurisdiction.
            </p>
          </section>

          {/* Mediation */}
          <section>
            <h2 className="font-['Cormorant_Garamond'] text-3xl font-light text-gray-900 mb-4">
              11. Consumer Mediation
            </h2>
            <p className="mb-4">
              In accordance with Articles L.616-1 and R.616-1 of the French Consumer Code, we offer a consumer mediation system.
            </p>
            <p className="mb-4">
              The mediation entity selected is: [Name of Mediator]
            </p>
            <p>
              In case of dispute, you can submit your complaint on the mediator's website: [Mediator Website]
            </p>
          </section>

          {/* Contact */}
          <section>
            <h2 className="font-['Cormorant_Garamond'] text-3xl font-light text-gray-900 mb-4">
              12. Contact
            </h2>
            <p className="mb-2">
              For any questions or requests regarding these legal notices, you can contact us:
            </p>
            <p className="mb-2">
              <strong>By email:</strong> contact@example.com
            </p>
            <p className="mb-2">
              <strong>By phone:</strong> +33 (7) 49 23 94 72
            </p>
            <p>
              <strong>By mail:</strong> [Complete Postal Address]
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
